import type { IAPI } from '../../apiResponse';
import type { IRequestOptions } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IBrowseCollectionsData } from '../browseCollections';
import { listFeaturedCollectionsV2ResponseSchema } from './list-featured-collections-v2-response';

export async function listFeaturedCollectionsV2Api(options?: IRequestOptions) {
  return getRequest<IAPI<IBrowseCollectionsData>>({
    path: '/collections/v2/featured',
    schema: listFeaturedCollectionsV2ResponseSchema,
    options,
  });
}
